import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-[#FAFAFA]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl tracking-tight">OFERTAS</div>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            El directorio local que pone tu negocio en la mente de tus vecinos. Una colonia, un código postal, miles de clientes.
          </p>
        </div>
        <div>
          <div className="overline text-muted-foreground">Plataforma</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/directorios" className="hover:text-[hsl(var(--primary))]">Directorios</Link></li>
            <li><Link to="/ganadores" className="hover:text-amber-500">🏆 Ganadores de la rifa</Link></li>
            <li><Link to="/registro" className="hover:text-[hsl(var(--primary))]">Registrar comercio</Link></li>
            <li><Link to="/login" className="hover:text-[hsl(var(--primary))]">Iniciar sesión</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-muted-foreground">Empresa</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/quienes-somos" className="hover:text-[hsl(var(--primary))]" data-testid="footer-about">Quiénes somos</Link></li>
            <li><Link to="/terminos" className="hover:text-[hsl(var(--primary))]" data-testid="footer-terms">Términos de Servicio</Link></li>
            <li><Link to="/privacidad" className="hover:text-[hsl(var(--primary))]" data-testid="footer-privacy">Aviso de Privacidad</Link></li>
            <li><Link to="/registro-promotor" className="hover:text-[hsl(var(--primary))]" data-testid="footer-promoter-register">Internacional</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-muted-foreground">Contacto</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>Marketing de Inteligencia Artificial S. de R.L. de C.V.</li>
            <li className="text-muted-foreground leading-relaxed">Av. Las Américas 1545, pisos 20, 21 y 22, Col. Providencia, Guadalajara, Jalisco, México.</li>
            <li>Tel: <a href="tel:+523317381875" className="hover:text-[hsl(var(--primary))] font-mono">33 1738 1875</a></li>
            <li>Correo: <a href="mailto:hola@ofertas.mx" className="hover:text-[hsl(var(--primary))]">hola@ofertas.mx</a></li>
            <li className="pt-2">
              <Link
                to="/login?admin=1"
                className="inline-flex items-center gap-1.5 text-[#5B21B6] hover:text-[#7C3AED] font-semibold"
                data-testid="footer-admin-login"
              >
                <ShieldCheck className="w-3.5 h-3.5" />
                Login admin
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Marketing de Inteligencia Artificial S. de R.L. de C.V. — Hecho en México 🇲🇽
      </div>
    </footer>
  );
}
